import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  CardHeader,
  Table,
  Container,
  Row,
  Input,
  Col,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { reportmanageService } from "../../../services/reportmanageService";
import { usermanageService } from "../../../services/usermanageService";

const ClientHoursReport = () => {
  const [reportData, setReportData] = useState([]);
  const [uniqueUsersList, setUniqueUsersList] = useState([]);
  const [filterMonth, setFilterMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  });
  const [selectedClient, setSelectedClient] = useState(""); // client filter
  const [loading, setLoading] = useState(false);

  // 🧩 Fetch client dropdown data
  const getUniqueUsersList = () => {
    usermanageService.getclient().then((response) => {
      if (response?.data?.clients) {
        setUniqueUsersList(response.data.clients);
      }
    });
  };

  // 📅 Fetch report data (by month + client)
  const getReportData = async (monthValue = "", client = "") => {
    try {
      setLoading(true);

      let startDate = "";
      let endDate = "";

      if (monthValue) {
        const [year, month] = monthValue.split("-");
        const monthNum = parseInt(month, 10);
        startDate = `${year}-${String(monthNum).padStart(2, "0")}-01`;
        const lastDay = new Date(year, monthNum, 0).getDate();
        endDate = `${year}-${String(monthNum).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`;
      }

      console.log("Payload:", { start_date: startDate, end_date: endDate, client });

      const response = await reportmanageService.getClientHoursReport({
        start_date: startDate,
        end_date: endDate,
        client, // pass client name or ID to backend
      });

      if (response.status === 200 && response.data.status) {
        setReportData(response.data.data);
      } else {
        setReportData([]);
      }
    } catch (error) {
      console.error("Error fetching report:", error);
      setReportData([]);
    } finally {
      setLoading(false);
    }
  };
 // Download Excel
  const downloadReport = () => {
    const [year, month] = filterMonth.split("-");
    const lastDay = new Date(year, month, 0).getDate();
    const startDate = `${year}-${month}-01`;
    const endDate = `${year}-${month}-${String(lastDay).padStart(2, "0")}`;

    reportmanageService.getJobAllocationReportDataDownload(startDate, endDate,selectedClient);
  };

  // 🚀 Initial Load
  useEffect(() => {
    getUniqueUsersList();
    getReportData(filterMonth);
  }, []);

  // 🕒 When month changes
  const handleMonthChange = (e) => {
    const selectedMonth = e.target.value;
    setFilterMonth(selectedMonth);
    getReportData(selectedMonth, selectedClient);
  };

  // 👤 When client changes
  const handleClientChange = (e) => {
    const selected = e.target.value;
    setSelectedClient(selected);
    getReportData(filterMonth, selected);
  };
  
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row className="mb-3">
          <Col>
            <h2>Client Hours Report</h2>
          </Col>
        </Row>

        <Card className="shadow">
          <CardHeader className="d-flex flex-wrap align-items-center justify-content-between">
            {/* Client Filter */}
            <div className="col-md-3 mb-2">
              {/* <h4 className="mb-1">Select Client</h4> */}
              <select
                className="form-control"
                name="client"
                onChange={handleClientChange}
                value={selectedClient}
              >
                <option value="">All Clients</option>
                {uniqueUsersList.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            {/* Month Filter */}
            <div className="d-flex   col-md-4 col-md-3 mb-2">
              <Input
                type="month"
                name="month"
                value={filterMonth}
                onChange={handleMonthChange}
                className="form-control"
              />&nbsp;&nbsp;
              <Button
                color="primary"
                onClick={() => getReportData(filterMonth, selectedClient)}
              >
                Refresh
              </Button>
             
            </div>
             <Col xs={2}>
                                  <div className="col-xl-12 col-md-12 col-xs-12 ">
                                    <Button
                                      className="btn-icon-clipboard"
                                      type="button"
                                      onClick={(e)=>downloadReport()}
                                      title="Download Report"
                                    >
                                      <i className="fas fa-download" style={{ fontSize: '14px' }}></i> Export
                                    </Button>
                                  </div>
                                  </Col>
          </CardHeader>

          <Table className="align-items-center table-flush" responsive>
            <thead className="thead-light">
              <tr>
                <th>Client Name</th>
                <th>No. of Jobs</th>
                <th>Estimated Hours</th>
                <th>Target Hours</th>
                <th>Difference</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : reportData.length > 0 ? (
                reportData.map((item, i) => (
                  <tr
                    key={i}
                    className={
                      i % 2 === 0
                        ? "blue-row"
                        : i % 3 === 0
                        ? "purple-row"
                        : "orange-row"
                    }
                  >
                    <td>{item.client_name}</td>
                    <td>{item.no_of_jobs}</td>
                    <td>{item.estimated_hours}</td>
                    <td>{item.target_hours}</td>
                    <td
                      style={{
                        color:
                          item.difference < 0
                            ? "red"
                            : item.difference > 0
                            ? "green"
                            : "inherit",
                      }}
                    >
                      {item.difference}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </Card>
      </Container>
    </>
  );
};

export default ClientHoursReport;
